// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__e8QIq","logo-link":"Logo_logo-link__2SeSU"};